import React from 'react';
import { NavigationContainerRef, ParamListBase } from '@react-navigation/native';
import { isWeb } from './platform';

export const tabNavigationRef = React.createRef();
export const navigationRef = React.createRef<NavigationContainerRef<ParamListBase>>();
export const test = React.createRef();
export const isReadyRef = React.createRef();

export const navigateBack = (navigateBackFallback: string = 'Machines', fallbackParams?: Record<string, unknown>) => {
  if (navigationRef.current?.canGoBack()) {
    navigationRef.current.goBack();
  } else {
    navigateTo(navigateBackFallback, fallbackParams);
  }
};

export const navigate = (name: string, params: Record<string, unknown>) => {
  const routes = navigationRef.current?.getRootState().routeNames;
  if (routes?.includes(name)) {
    console.log('NAVIGATE:', name, params);
    navigationRef.current?.navigate({ name, params, key: `${name}-${Math.floor(Math.random() * 1000)}` });
  } else {
    try {
      if (tabNavigationRef.current) {
        console.log('NAVIGATE TAB:', name, params);
        tabNavigationRef.current.navigate(name, { screen: params.screen, ...params });
        if (params?.params?.screen) {
          setTimeout(() => {
            tabNavigationRef.current.navigate(name, params);
          }, 1);
        }
        return;
      }
    } catch (e) {}
    console.log('ROUTER NOT FOUND:', name);
    navigationRef.current?.navigate('Authorized');
  }
};

export const navigateTo = (r: string, params?: Record<string, unknown>) => {
  try {
    if (isReadyRef.current) {
      navigate(r, params);
    } else {
      setTimeout(() => {
        navigateTo(r, params);
      }, 2);
    }
  } catch (e) {
    console.log('Navigation error:', e);
  }
};

export const getLastParams = (params: Record<string, unknown> | undefined): Record<string, unknown> | undefined => {
  if (!params) {
    return params;
  }

  if (params?.params) {
    return getLastParams(params.params);
  }
  return params;
};

const nestedList = ['connection'];

export const getStateParams = (route: Record<string, unknown> | undefined) => {
  const list = isWeb ? window.location.pathname.split('/').filter((i) => !nestedList.includes(i)) : [];
  const params = getLastParams(route?.params) || { id: list[list.length - 1] };
  return params;
};

export const resetTo = (name: string, params?: Record<string, unknown>) => {
  navigationRef.current?.reset({
    index: 1,
    routes: [
      {
        name,
        params,
      },
    ],
  });
};

const ANONYM_PATHS = ['/connect', '/connector-linked', '/user-email', '/user-details', '/user-password'];

export const isAnonymPath = () => {
  if (isWeb) {
    const path = window.location.pathname;
    return ANONYM_PATHS.includes(path);
  }

  return false;
};

export const isRouteParamTruthy = (value: unknown) => (typeof value === 'string' ? value === 'true' : typeof value === 'boolean' ? value : false);

// URL query params always arrive as strings, but ID fields (ncFileId, partId, productionOperationId, etc.)
// are numbers in reducers/selectors and strict equality checks (`=== 101`) fail against `'101'`.
// Returns +value when it parses as a finite number, otherwise the original value untouched.
export const parseRouteParamAsNumber = <T>(value: T): T | number => {
  if (value == null) return value;
  const num = +(value as unknown as number);
  return Number.isFinite(num) ? num : value;
};
